import { render, staticRenderFns } from "./IncludedProtocols.vue?vue&type=template&id=24ff112e&"
import script from "./IncludedProtocols.vue?vue&type=script&lang=js&"
export * from "./IncludedProtocols.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports